import React from 'react';

interface ProjectAvatarProps {
  size?: number;
  className?: string;
}

export const ProjectAvatar = ({size = 32, className}: ProjectAvatarProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}>
      <circle cx="32" cy="32" r="32" fill="#0D6EFF" />
      <path
        d="M47.585 15.3849C46.4508 17.4267 45.225 18.918 43.6682 20.0914C42.1854 21.208 40.7571 21.7869 33.8204 21.7869C16.942 21.7869 12.741 29.6674 11.9551 33.795C11.4787 36.3375 11.8347 38.9738 12.9658 41.2788C14.0969 43.5838 15.9372 45.4234 18.19 46.5009C20.9281 47.819 24.4644 48.6151 28.7421 48.6151H40.0009L42.8206 39.8688H30.425C24.6621 39.8688 19.7864 38.0596 19.223 33.3401C18.919 30.8408 19.7469 27.946 23.2486 25.9818C25.5023 24.7256 28.8632 23.7357 33.7512 23.7357C39.2299 23.7357 40.3469 24.3586 41.2835 25.2477C43.2085 27.0699 42.8477 29.7837 42.8206 30.13C45.6402 25.4648 48.8206 23.2602 52.2507 22.7613C48.9417 21.7456 47.3379 19.3212 47.585 15.3849Z"
        fill="white"
      />
    </svg>
  );
};
